const webshopKeyToName = {
    bolcom: 'Bol.com',
    lightspeed: 'Lightspeed',
    shopify: 'Shopify',
    woocommerce: 'WooCommerce',
    prestashop: 'PrestaShop',
    magento: 'Magento',
    ccvshop: 'CCV Shop',
    mijnwebwinkel: 'Mijnwebwinkel',
    shoptrader: 'Shoptrader',
    snelstart: 'SnelStart',
    exactOnline: 'Exact Online',
    shopware: 'Shopware',
    picqer: 'Picqer',
    goedgepickt: 'Goedgepickt',
    nshift: 'nShift'
}

export default webshopKeyToName
